import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal } from 'antd';

class FirstModal extends Component {
  render() {
    const { visible, children, className, footer, onCancel } = this.props;
    return (
      <Modal
        open={visible}
        wrapClassName={`first-charge-wrap ${className}`}
        centered={true}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
        zIndex={1006}
      >
        <span className="btn-close" onClick={onCancel} />
        <div className="title" />
        {children}
        {/* 底部按钮 */}
        <div className="btn-change-wrap">{footer}</div>
      </Modal>
    );
  }
}

export default withRouter(FirstModal, { withRef: true });
